export { useResizeObserver } from '@openshift-console/plugin-shared/src/hooks/useResizeObserver';
